import { createActions } from 'redux-actions'
import { Error } from 'types'

export const {
  filter: {
    changeCountry,
    changeZone,
    changeStatus,
    changeProduct,
    changeType,
    changeShipTo,
    changeTankId,
    changeGeoZones,
    changeCustomer,
    updateOriginalResult,
    updateFilteredResult,
  },
} = createActions({
 '@filter/changeCountry': (country: string) => ({ country }),
  '@filter/changeZone': (zone: string) => ({ zone }),
  '@filter/changeStatus': (status: string) => ({ status }),
  '@filter/changeProduct': (product: string) => ({ product }),
  '@filter/changeType': (type: string) => ({ type }),
  '@filter/changeShipTo': (sh: string) => ({ sh }),
  '@filter/changeTankId': (tankId: string) => ({ tankId }),
  '@filter/changeGeoZones': (geoZone: string) => ({ geoZone }),
  '@filter/changeCustomer': (customer: string) => ({ customer }),
  '@filter/updateOriginalResult': (tanks: any, geos: any, error: Error) => ({
    tanks,
    geos,
    error,
  }),
  '@filter/updateFilteredResult': (tanks: any, geos: any) => ({
    tanks,
    geos,
  }),
})
